import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Callout, FormSection, Paragraph } from 'admination-react'
import { getProfil, isEingeschraenkt } from '../../api/teilnehmerakte-staff'
import { VerbisLebenslaufNachreichen } from '../verbis-lebenslauf/VerbisLebenslaufNachreichen'
import { AnwesenheitscodeSection } from './anwesenheitscode-section'
import { RueckzugSection } from './rueckzug-section'

type Stand = { kind: 'loading' } | { kind: 'error' } | { kind: 'eingeschraenkt' } | { kind: 'ready' }

/** The Vergabe profile of one coaching, as sections of the person window's Übersicht. */
export function ProfilSections({ coachingId }: { coachingId: string }) {
  const { t } = useTranslation('vergabeStaff')
  const [stand, setStand] = useState<Stand>({ kind: 'loading' })
  const [attempt, setAttempt] = useState(0)

  useEffect(() => {
    let cancelled = false
    setStand({ kind: 'loading' })
    getProfil(coachingId)
      .then(() => {
        if (!cancelled) setStand({ kind: 'ready' })
      })
      .catch((error: unknown) => {
        if (cancelled) return
        setStand(isEingeschraenkt(error) ? { kind: 'eingeschraenkt' } : { kind: 'error' })
      })
    return () => {
      cancelled = true
    }
  }, [coachingId, attempt])

  if (stand.kind === 'eingeschraenkt') {
    return (
      <FormSection>
        <Callout tone="error" role="alert" title={t('profil.eingeschraenktTitle')}>
          {t('profil.eingeschraenktText')}
        </Callout>
      </FormSection>
    )
  }

  if (stand.kind !== 'ready') {
    return (
      <FormSection>
        {stand.kind === 'loading' ? (
          <Paragraph variant="muted" aria-busy="true">
            {t('profil.loading')}
          </Paragraph>
        ) : (
          <>
            <Callout tone="error" role="alert">
              {t('profil.loadError')}
            </Callout>
            <div>
              <Button onClick={() => setAttempt((n) => n + 1)}>{t('profil.retry')}</Button>
            </div>
          </>
        )}
      </FormSection>
    )
  }

  return (
    <>
      <VerbisLebenslaufNachreichen coachingId={coachingId} />
      <AnwesenheitscodeSection coachingId={coachingId} />
      <RueckzugSection coachingId={coachingId} onEingeschraenkt={() => setStand({ kind: 'eingeschraenkt' })} />
    </>
  )
}
